<ion-button
  [fill]="fill"
  expand="block"
  [color]="color"
  class="ion-no-margin"
  [disabled]="disabled"
  (click)="onClick($event)">
  <ng-content></ng-content>
</ion-button>